import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "confirmacao",
    templateUrl: "./confirmacao.component.html",
    styleUrls: ["./confirmacao.component.scss"],
})
export class ConfirmacaoComponent implements OnInit {
    @Input() title: string;
    @Input() message: string;
    @Input() btnOkText: string = "Confirmar";
    @Input() btnCancelText: string = "Cancelar";
    @Input() typeButton: string = "danger";

    constructor(private activeModal: NgbActiveModal) {}

    ngOnInit() {}

    public decline() {
        this.activeModal.close(false);
    }

    public accept() {
        this.activeModal.close(true);
    }

    public dismiss() {
        this.activeModal.dismiss();
    }
}
